import { render, staticRenderFns } from "./PosMultiOrg.vue?vue&type=template&id=55529ca6&"
import script from "./PosMultiOrg.vue?vue&type=script&lang=js&"
export * from "./PosMultiOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports